/*
Copyright (C) 2018 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

export default defineMessages({
  stripePartialWarning: {
    id: 'OrderFulfillmentView.ItemGrid.StatusChange.stripePartialWarning',
    defaultMessage:
      'Stripe does not allow a payment to be fully processed if only some of the items are being fulfilled.{breakLine}' +
      'If you proceed while not fulfilling all listed items, be aware that any items not being fulfilled {important}.{breakLineWide}' +
      'To proceed, you can:{breakLine}' +
      '1) Keep the items unselected and cancel them {breakLine}' +
      '2) Go back and fulfill all listed items {breakLine}' +
      '{breakLine}'
  },
  stripePartialWarningTitle: {
    id: 'OrderFulfillmentView.ItemGrid.StatusChange.stripePartialWarningTitle',
    defaultMessage: 'Partial Stripe Process Payment'
  },
  stripePartialWarningCancel: {
    id: 'OrderFulfillmentView.ItemGrid.StatusChange.stripePartialWarningCancel',
    defaultMessage: 'Cancel'
  },
  stripePartialWarningContinue: {
    id: 'OrderFulfillmentView.ItemGrid.StatusChange.stripePartialWarningContinue',
    defaultMessage: 'Continue'
  },
  stripePartialWarningImportant: {
    id: 'OrderFulfillmentView.ItemGrid.StatusChange.stripePartialWarningImportant',
    defaultMessage: 'will be cancelled'
  },
  dealerInvoiceNumberRequired: {
    id: 'OrderFulfillmentView.ItemGrid.StatusChange.dealerInvoiceNumberRequired',
    defaultMessage: 'Dealer Invoice Number is required'
  },
  purchaseOrderNumberRequired: {
    id: 'OrderFulfillmentView.ItemGrid.StatusChange.purchaseOrderNumberRequired',
    defaultMessage: 'Purchase Order Number is required'
  }
});
